import { router } from '~/router';
import Table from 'Components/SimpleTable';
import { sortBy } from 'lodash';
import React from 'react';

const columns = [
    { label: 'Organization', dataKey: 'organization_name' },
    { label: 'Site', dataKey: 'site_name' },
    { label: 'Root Device', dataKey: 'root_device_name' },
    { label: 'Device', dataKey: 'device_name' },
    { label: 'Name', dataKey: 'name' }
];

const Measurements = props => {
    const { measurements = [] } = props;

    const
        onRowClick = (_id, measurement) => router.navigate(`/devices/${measurement.device_id}/measurements`),
        rows = sortBy(measurements, ['organization_name', 'site_name', 'root_device_name', 'device_name', 'name']);

    return (
        <Table columns={columns} onRowClick={onRowClick} rows={rows} rowsPerPage={500}/>
    );
};

export default Measurements;
